(function ($, document) {
    'use strict';

    $(document).on('click', '.review-vote-positive', function (e) {
        var
            $this = $(this),
            url = $this.attr('href'),
            $content = $this.closest('.review-helpful-container');

        $.post(url).success(function (response) {
            var cssClass = response.success ? 'success' : 'warning';

            $content.empty().addClass('aler alert-' + cssClass).html(response.message);
        });

        e.preventDefault();
    });

    $(document).on('click', '#add-review-btn', function (e) {
        var
            $addReviewActionResponse = $('#add-review-action-response'),
            $this = $(this),
            $form = $this.closest('form'),
            url = $form.attr('action'),
            params = {
                review: {
                    content: $('#review-content').val(),
                    rating: $('#review-rating').val(),
                    submitter_name: $('#review-submitter-name').val(),
                    submitter_company: $('#review-submitter-company').val()
                }
            };

        $.post(url, params).then(function (response) {
            var cssClass = response.success ? 'success' : 'warning';

            if(response.auth_required) {
                $('#login-modal').modal();
                return false;
            }

            $form.fadeOut(100, function () {
                $addReviewActionResponse.hide().removeClass('hidden alert-danger alert-success').addClass('alert-' + cssClass).html(response.message).fadeIn(100);
            });
        }).fail(function(response) {
            console.log(response);
            var
                errors  = [],
                data    = $.parseJSON(response.responseText);

            $.each(data, function(field) {
                errors.push(data[field][0]);
            });

            $addReviewActionResponse.hide().removeClass('hidden alert-danger alert-success').addClass('alert-danger').html(errors.join('<br>')).fadeIn(100);
        });

        e.preventDefault();
    });

    $(document).on('click', '.open-product-tab', function(e) {
        e.preventDefault();
        var id = $(this).attr('href');

        $('html, body').animate({
            scrollTop: $("#main-content-container").offset().top - 70
        }, 10);

        $('a[data-toggle=tab][href="' + id + '"]').tab('show'); 
        
		window.location.hash = id;       
    });

    $(document).on('mouseover', '#change-review-rating .rating-item', function () {
        var $this = $(this);

        $this.nextAll().removeClass('active');
        $this.prevAll().andSelf().addClass('active');
    });

    $(document).on('mouseout', '#change-review-rating .rating-item', function () {
        var
            $changeReviewRating = $('#change-review-rating'),
            lastRating = $changeReviewRating.data('last-rating');

        $changeReviewRating.find('> .rating-item').each(function () {
            var $this = $(this);

            if ($this.data('rating') <= lastRating) {
                $this.addClass('active');
            }
        });
    });

    $(document).on('click', '#change-review-rating .rating-item', function () {
        var rating = $(this).data('rating');

        $('#change-review-rating').data('last-rating', rating);
        $('#review-rating').val(rating);
    });

    window.onkeydown = function(e){
        if(e.keyCode == 70 && e.ctrlKey){
            $('.product-features-collapsible-list > .collapse-item').addClass('active');
            $('.product-features-collapsible-list > .collapse-item > .item-body').slideDown(250);
        }
    }


})(jQuery, document);
